import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useMediaQuery } from '@uidotdev/usehooks';
import { TagIcon, UsersIcon, Cog6ToothIcon } from '@heroicons/react/24/solid';

interface IconProps {
  className?: string;
}

const TeamButton = ({
  children,
  link,
  icon: Icon,
  disabled,
}: {
  children: ReactElement | string;
  link: string;
  icon: React.ComponentType<IconProps>;
  disabled?: boolean;
}) => {
  const location = useLocation();

  const isActiveRoute = location.pathname.includes(link);
  const isSmallDevice = useMediaQuery('only screen and (max-width : 1024px)');

  return (
    <Link to={link}>
      <button
        disabled={disabled}
        className={`${
          isActiveRoute
            ? 'border-b-2 border-primary font-medium text-primary'
            : ''
        } ${
          disabled ? 'cursor-not-allowed text-custom-surface-400' : ''
        } flex w-28 flex-col items-center justify-center gap-2 py-2 text-sm transition-all duration-200 lg:w-52 lg:flex-row lg:items-start`}
      >
        <Icon
          className={`h-5 w-5 ${isActiveRoute ? 'fill-primary' : ''} ${
            disabled ? 'fill-custom-surface-400' : ''
          } transition-all duration-200`}
        />
        <p>{children}</p>
      </button>
    </Link>
  );
};

export const TeamNavigation = () => {
  const [t] = useTranslation('teams');

  return (
    <div className="my-8 flex flex-row border-b border-custom-surface-400">
      <TeamButton link="users" icon={UsersIcon}>
        {t('title_users')}
      </TeamButton>
      <TeamButton link="tags" icon={TagIcon}>
        {t('title_tags')}
      </TeamButton>
      <TeamButton link="profile" icon={Cog6ToothIcon}>
        {t('title_profile_settings')}
      </TeamButton>
    </div>
  );
};
